export module YoutubeModalModule {
  export class Service {
    private StyledYoutubeModals: NodeListOf<HTMLElement>;

    constructor() {
      this.StyledYoutubeModals = document.querySelectorAll('.StyledYoutubeModal');
      document.addEventListener('readCompleteAction', this.setEvent.bind(this));
    }

    private setEvent() {
      this.StyledYoutubeModals.forEach(StyledYoutubeModal => {
        const StyledYoutubeModal__closeButton = StyledYoutubeModal.querySelector('.StyledYoutubeModal__closeButton') as HTMLElement;
        if (StyledYoutubeModal__closeButton) {
          StyledYoutubeModal__closeButton.addEventListener('click', (e) => {
            e.preventDefault();

            // StyledYoutubeModal に　data-scroll があれば、スクロール位置を戻す
            const scrollPosition = StyledYoutubeModal.getAttribute('data-scroll');
            if (scrollPosition) {
              window.scrollTo({
                top: Number(scrollPosition),
              });
            }
            // StyledYoutubeModal から　data-scroll を削除する
            StyledYoutubeModal.removeAttribute('data-scroll');
            StyledYoutubeModal.classList.remove('is-open');

            // body から　is-modal-open を削除する
            const body = document.querySelector('body');
            body?.classList.remove('is-modal-open');

            // YouTube動画を停止する
            this.close();
          });
        }
      });
    }

    private close() {
      // #youtubeIframe にあるiframe を取得
      const div = document.querySelector('[id="#youtubeIframe"]')
      if (div) {
        const iframe = (div.querySelector('iframe') as HTMLIFrameElement).contentWindow;
        if (iframe) {
          iframe?.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        }
      }
    }
  }
}
